/*
 * Shared PWA helpers used by both the staff (InstallPrompt.jsx) and customer
 * (CustomerInstallPrompt.jsx) install banners.
 */

export function isStandalone() {
  if (typeof window === "undefined") return false;
  return (
    window.matchMedia?.("(display-mode: standalone)").matches ||
    window.navigator.standalone === true
  );
}

export function detectPlatform() {
  if (typeof window === "undefined") return "unknown";
  const ua = window.navigator.userAgent;
  const isIOS = /iPhone|iPad|iPod/.test(ua) && !window.MSStream;
  const isAndroid = /Android/.test(ua);
  const isSafari = /^((?!chrome|android|crios|fxios).)*safari/i.test(ua);
  if (isIOS) return isSafari ? "ios-safari" : "ios-other";
  if (isAndroid) return "android";
  return "desktop";
}

export function isDismissed(key, cooldownDays = 14) {
  try {
    const ts = localStorage.getItem(key);
    if (!ts) return false;
    const age = Date.now() - parseInt(ts, 10);
    return age < cooldownDays * 24 * 3600 * 1000;
  } catch {
    return false;
  }
}

export function markDismissed(key) {
  try { localStorage.setItem(key, String(Date.now())); } catch {}
}
